/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 単価マスタ更新情報
 */
export interface Szza027aRequestTankaMasterUpdateInfDto { 
    /**
     * プロダクトコード：英数字
     */
    prdCode: string;
    /**
     * 商品コード：英数字
     */
    goodsCode: string;
    /**
     * 料金計算定義料金コード：英数字
     */
    chargeCode: string;
    /**
     * 単価指定区分１コード：数字
     */
    tankaSiteiDiv1: string;
    /**
     * 単価指定区分２コード：数字
     */
    tankaSiteiDiv2: string;
    /**
     * 単価指定区分３：数字
     */
    tankaSiteiDiv3: string;
    /**
     * 単価指定区分４：数字
     */
    tankaSiteiDiv4: string;
    /**
     * 単価指定区分５：数字
     */
    tankaSiteiDiv5: string;
    /**
     * 単価範囲開始値：数字<br>　精度(3)
     */
    tankaRangeStart: number;
    /**
     * 適用開始日付(変更前)：日付(yyyyMMdd)<br>　「マスタ登録区分」＝\'2\'（変更）、\'3\'（削除）の場合に設定
     */
    applyStartDateBefore?: string | null;
    /**
     * 適用開始日付(変更後)：日付(yyyyMMdd)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定
     */
    applyStartDate?: string | null;
    /**
     * 適用終了日付：日付(yyyyMMdd)
     */
    applyEndDate: string;
    /**
     * 更新通番号：数字<br>　「マスタ登録区分」＝\'2\'（変更）、\'3\'（削除）の場合に設定
     */
    updateSrno?: string | null;
    /**
     * 単価正式名称：全角
     */
    tankaAname: string;
    /**
     * 単価略称名称：全角
     */
    tankaRyaku: string;
    /**
     * 単価範囲終了値：数字<br>　精度(3)
     */
    tankaRangeEnd: number;
    /**
     * 単価：数字<br>　精度(3)
     */
    tanka: number;
    /**
     * 調整単価コード：数字<br>　画面項目ID＝\'C001300\'
     */
    unitFracCalc?: string | null;
    /**
     * 単位：数字
     */
    unit?: number | null;
    /**
     * 超過単価：数字<br>　精度(3)
     */
    exceedTanka?: number | null;
    /**
     * 超過単位：数字
     */
    exceedUnit?: number | null;
}

